(ns practitest.frontend.milestones
  (:require
   [ajax.core :as ajax]
   [practitest.frontend.common-entities.events :as common-events]
   [practitest.frontend.common.dom :as dom]
   [practitest.frontend.common.format-utils :as fu]
   [practitest.frontend.common.i18n :refer [format-translation get-translation] :as i18n]
   [practitest.frontend.forms3.entity-form.utils :refer [get-modal-title]]
   [practitest.frontend.common.mixpanel :as mixpanel]
   [practitest.frontend.common.permissions :as permissions]
   [practitest.frontend.common.re-frame :refer [partial-dispatch]]
   [practitest.frontend.components.card-view :as card-view]
   [practitest.frontend.components.grid.events :as grid.events]
   [practitest.frontend.components.grid.localstorage :as grid-storage]
   [practitest.frontend.components.grid.sessionstorage :as grid-session-storage]
   [practitest.frontend.components.grid.subs :as grid.subs]
   [practitest.frontend.components.icons :as icons]
   [practitest.frontend.components.notifications :as notifications]
   [practitest.frontend.components.selector2 :as selector2]
   [clojure.string :as str]
   [practitest.frontend.common.bugtrackers :as bugtrackers]
   [practitest.frontend.common.dom :as dom]
   [practitest.frontend.components2.add-entities :as add-entities]
   [practitest.frontend.components2.buttons :as buttons]
   [practitest.frontend.components2.entity-form :as entity-form]
   [practitest.frontend.components2.info-note :as info-note]
   [practitest.frontend.issue.bugtracker :as bugtracker]
   [practitest.frontend.components2.entity-form.forms :as forms]
   [practitest.frontend.components2.grid :as grid2]
   [practitest.frontend.components2.grid.common :as grid2.common]
   [practitest.frontend.components2.grid.fields :refer [transform-fields]]
   [practitest.frontend.components2.search-box :as search-box]
   [practitest.frontend.events :as events]
   [practitest.frontend.forms3.entity-form :as f3.entity-form]
   [practitest.frontend.forms3.milestone :as f3.milestone-form]
   [practitest.frontend.milestone.charts :refer [dashboard-pie-chart
                                                 dashboard-progress-chart
                                                 main-page-chart]]
   [practitest.frontend.milestone.events :as milestone.events]
   [practitest.frontend.milestone.subs :as milestone.subs]
   [practitest.frontend.routing.backend-routes :as broutes]
   [practitest.frontend.routing.router :as router]
   [practitest.frontend.subs :as subs]
   [practitest.frontend.forms3.entity-form.collab-ws :as collab-ws]
   [practitest.frontend.common-entities.metadata :as metadata]
   [practitest.frontend.milestone.readiness-index :as ri]
   [practitest.frontend.milestone.readiness-index.events :as ri.events]
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]))

(defn- index-by [f coll]
  (into {} (map (juxt f identity)) coll))

(def current-entity :milestone)
(def metadata (get metadata/entities-metadata current-entity))
(def ^:private milestone-form-id :milestone-main)


(defmethod grid.subs/columns :requirements-state [[_current-project entity-fields fields users groups folders] [_ [_entity _]]]
  (concat
   [{:type          :external_id_or_display_id
     :field         :display_id
     :default-width 80
     :default-show? true
     :autofilter?   true
     :header        (get-translation "generic.label.id" "ID")}
    {:type          :url
     :field         :name
     :default-width 250
     :autofilter?   true
     :header        (get-translation "generic.label.name" "Name")}
    {:type          :external_id_or_display_id 
     :field         :external_id
     :default-width 120
     :default-show? false
     :autofilter?   true
     :header        (get-translation "generic.label.external-id" "External ID")}
    {:type          :testing-scope
     :default-width 200
     :autofilter?   true
     :sortable?     true
     :header        (get-translation "test.label.testing-scope" "Testing Scope")
     :field         :testing_scope}]
    ;; NOTE: `requirement_status` here is scoped by the milestone
   (transform-fields [:requirement_status :updated_at]
                     (dissoc (:requirement entity-fields) :description)
                     fields users groups folders)))

;; non-clickable name
(grid2.common/register-field-type!
 :nc-name
 grid2.common/header-title
 (fn [{:keys [field]} row]
   (:title row))
 (fn [{:keys [field]} row]
   (:title row)))

(defmethod grid.subs/columns :link-requirements-state [[_current-project entity-fields fields users groups folders] [_ [_entity _]]]
  (concat
   [{:type           :display_id
     :field          :display_id
     :default-width  80
     :default-show?  true
     :autofilter?    true
     :header         (get-translation "generic.label.id" "ID")}
    {:type           :nc-name
     :field          :name
     :default-width  250
     :autofilter?    true
     :header         (get-translation "generic.label.name" "Name")}
    {:type           :linked-entities
     :field          :linked_milestones
     :default-width  80
     :default-show?  true
     :autofilter?    true
     :header         (get-translation "milestone.plural" "Milestones")}
    {:type           :display_id
     :field          :external_id
     :default-width  120
     :default-show?  false
     :autofilter?    true
     :header         (get-translation "generic.label.external-id" "External ID")}]
   (transform-fields [:updated_at]
                     (dissoc (:requirement entity-fields) :description :linked_milestones)
                     fields users groups folders)))


(defmethod grid.subs/columns :testsets-state [[_current-project entity-fields fields users groups folders] [_ [_entity _]]]
  (concat
   [{:type          :display_id
     :field         :display_id
     :default-width 80
     :default-show? true
     :autofilter?   true
     :header        (get-translation "generic.label.id" "ID")}
    {:type          :url
     :field         :name
     :default-width 250
     :autofilter?   true
     :header        (get-translation "generic.label.name" "Name")}
    {:type          :text
     :field         :instances_count
     :default-width 120
     :default-show? false
     :autofilter?   true
     :header        (get-translation "instance.instances-count" "Instances Count")}]
   (transform-fields [:run_status :last_run :assigned_to]
                     (dissoc (:testset entity-fields) :description)
                     fields users groups folders)))

(defmethod grid.subs/columns :link-testsets-state [[_current-project entity-fields fields users groups folders] [_ [_entity _]]]
  (concat
   [{:type           :display_id
     :field          :display_id
     :default-width  80
     :default-show?  true
     :autofilter?    true
     :header         (get-translation "generic.label.id" "ID")}
    {:type           :nc-name
     :field          :name
     :default-width  250
     :autofilter?    true
     :header         (get-translation "generic.label.name" "Name")}
    {:type           :milestone
     :field          :milestone_id
     :default-width  80
     :default-show?  true
     :autofilter?    true
     :header         (get-translation "milestone.singular" "Milestone")}
    {:type           :text
     :field          :instances_count
     :default-width  120
     :default-show?  false
     :autofilter?    true
     :header         (get-translation "instance.instances-count" "Instances Count")}]
   (transform-fields [:run_status :last_run :assigned_to]
                     (dissoc (:testset entity-fields) :description :milestone_id)
                     fields users groups folders)))


(defmethod grid.subs/columns :issues-state [[_current-project entity-fields fields users groups folders] [_ [_entity _]]]
  (concat
   [{:type          :external_id_or_display_id
     :field         :display_id
     :default-width 80
     :default-show? true
     :autofilter?   true
     :header        (get-translation "generic.label.id" "ID")}
    {:type          :url
     :field         :name
     :default-width 250
     :autofilter?   true
     :header        (get-translation "generic.label.name" "Name")}
    {:type          :external_id_or_display_id
     :field         :external_id
     :default-width 120
     :default-show? false
     :autofilter?   true
     :header        (get-translation "generic.label.external-id" "External ID")}]
   (transform-fields [:issue_status :priority :updated_at :assigned_to]
                     (dissoc (:issue entity-fields) :description)
                     fields users groups folders)))

(defmethod grid.subs/columns :link-issues-state [[_current-project entity-fields fields users groups folders] [_ [_entity _]]]
  (concat
   [{:type           :display_id
     :field          :display_id
     :default-width  80
     :default-show?  true
     :autofilter?    true
     :header         (get-translation "generic.label.id" "ID")}
    {:type           :nc-name
     :field          :title
     :default-width  250
     :autofilter?    true
     :header         (get-translation "generic.label.name" "Name")}
    {:type           :linked-entities
     :field          :linked_milestones
     :default-width  80
     :default-show?  true
     :autofilter?    true
     :header         (get-translation "milestone.plural" "Milestones")}
    {:type           :display_id
     :field          :external_id
     :default-width  120
     :default-show?  false
     :autofilter?    true
     :header         (get-translation "generic.label.external-id" "External ID")}]
   (transform-fields [:issue_status :priority :updated_at :assigned_to]
                     (dissoc (:issue entity-fields) :description :linked_milestones)
                     fields users groups folders)))

(defmethod grid.subs/columns :link-milestones-state [[_current-project entity-fields fields users groups folders] [_ [_entity _]]]
  (concat
   [{:type :display_id
     :field :display_id
     :default-width 80
     :default-show? true
     :autofilter? true
     :header (get-translation "generic.label.id" "ID")}
    {:type :text
     :field :name
     :default-width 250
     :autofilter? true
     :header (get-translation "generic.label.name" "Name")}]
   (transform-fields [:milestone_status :milestone_type]
                     (dissoc (:milestone entity-fields) :description)
                     fields users groups folders)))

(defmethod grid.subs/columns :link-tests-state [[_current-project entity-fields fields users groups folders] [_ [_entity _]]]
  (concat
    [{:type :display_id
      :field :display_id
      :default-width 80
      :default-show? true
      :autofilter? true
      :header (get-translation "generic.label.id" "ID")}
     {:type :test_type
      :field :test_type
      :header (get-translation "test.label.type" "Type")
      :autofilter? true}
     {:type :url
      :field :name
      :default-width 200
      :autofilter? true
      :header (get-translation "generic.label.name" "Name")}
     {:type          :linked-entities
      :default-width 200
      :autofilter?   false
      :sortable?     false
      :header        (get-translation "issue.linked" "Linked Issues")
      :field         :linked_issues}
     {:type          :linked-entities
      :default-width 200
      :autofilter?   false
      :sortable?     false
      :header        (get-translation "requirement.linked" "Linked Requirements")
      :field         :linked_requirements}
     {:type          :linked-entities
      :default-width 200
      :header        (get-translation "testset.linked" "Linked Test Sets")
      :autofilter?   false
      :sortable?     false
      :field         :linked_testsets}
     {:type          :number
      :field         :steps_count
      :autofilter?   true
      :text-align    "center"
      :multiple?     true
      :sortable?     true
      :header        (get-translation "test.label.steps-count" "Steps Count")}]
    (transform-fields []
                      (dissoc (:test entity-fields) :description :test_type)
                      fields users groups folders)))

(defn- fetch-charts-fx [db id]
  [:dispatch (if (subs/milestone-readiness-index-enabled? db)
               [::ri.events/fetch id]
               [::fetch-chart-data-by-id id])])

(defn set-milestone-visibility [{:keys [db]} [_ id visible?]]
  (let [milestone    (get-in db [:milestones id])
        old-visible? (boolean (:visible? milestone))
        rrqi?        (subs/milestone-readiness-index-enabled? db)
        cached?      (contains? milestone (if rrqi? :metrics/rrqi :charts))]
    (when-not (= old-visible? visible?)
      (cond-> {:db (assoc-in db [:milestones id :visible?] visible?)}
        (and visible? (not cached?))
        (assoc :fx [(fetch-charts-fx db id)])))))

(re-frame/reg-event-fx ::set-milestone-visibility set-milestone-visibility)

(defn api-error [{:keys [db]} [_ event _response]]
  {:db (update db :progress disj event)
   :fx [[:dispatch [::notifications/error2 "Error happened during operation" {:id "api-error-message"}]]]})

(re-frame/reg-event-fx ::api-error api-error)

(defn enrich-milestone [db {:keys [id milestone_status archived milestone_start_date milestone_end_date]
                            :as   milestone}]
  (let [project-id (subs/get-current-project-id db)
        today      (js/Date.)
        start-date (js/Date. milestone_start_date)
        end-date   (js/Date. milestone_end_date)
        status     (if archived "Archived" milestone_status)]
    (merge milestone {:project/id          project-id
                      :milestone/id        id
                      :milestone/status    status
                      :milestone/upcoming? (< today start-date)
                      :milestone/past?     (< end-date today)
                      :milestone/start-date start-date
                      :milestone/end-date   end-date
                      :milestone_status    status})))

(defn milestones-received
  "Merges fetched milestones to db, each milestone is merged with its
  existing db entry to preserve data fetched in parallel, which would
  otherwise be overwritten."
  [db [_ response]]
  (let [items      (:items response)
        db-lookup  #(get-in db [:milestones (:id %)])
        existing   (mapv db-lookup items)]
    (-> db
        (update :progress disj ::fetch)
        (assoc :milestones (->> (map merge existing items)
                                (map #(enrich-milestone db %))
                                (index-by :id))))))

(re-frame/reg-event-db ::received milestones-received)

(defn fetch-milestones [{:keys [db]} _]
  {:db         (update db :progress conj ::fetch)
   :http-xhrio {:method          :get
                :uri             (broutes/get-url "milestones#list" {:p_id (subs/get-current-project-id db)})
                :response-format (ajax/json-response-format {:keywords? true})
                :on-success      [::received]
                :on-failure      [::api-error ::fetch]}})

(re-frame/reg-event-fx ::fetch fetch-milestones)

(defn chart-data-received [db [_ id chart-data]]
  (assoc-in db [:milestones id :charts] chart-data))

(re-frame/reg-event-db ::chart-data-received chart-data-received)

(re-frame/reg-event-fx
  ::refresh-charts
  (fn [{db :db} [_ id]]
    (when (contains? (:milestones db) id)
      {:fx [(fetch-charts-fx db id)]})))

(defn fetch-chart-data [_ [_ milestone]]
  (let [uri (-> milestone :uris :charts)]
    {:http-xhrio {:method          :get
                  :uri             uri
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success      [::chart-data-received (:id milestone)]
                  :on-failure      [::api-error ::fetch-chart-data]}}))

(re-frame/reg-event-fx ::fetch-chart-data fetch-chart-data)

(defn fetch-chart-data-by-id [{db :db} [_ milestone-id]]
    {:http-xhrio {:method          :get
                  :uri             (broutes/get-url "milestones#charts_data"
                                                    {:p_id (subs/get-current-project-id db)
                                                     :id milestone-id})
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success      [::chart-data-received milestone-id]
                  :on-failure      [::api-error ::fetch-chart-data]}})

(re-frame/reg-event-fx ::fetch-chart-data-by-id fetch-chart-data-by-id)

(re-frame/reg-sub
 ::milestones
   (fn [db [_]]
     (:milestones db)))

(re-frame/reg-sub
 ::filtered-milestones
 :<- [::milestones]
 :<- [::milestone.subs/milestone-filter-statuses]
 (fn [[milestones statuses] [_ {:keys [search-string]}]]
   (->> milestones
        (vals)
        (filter #(and
                  (contains? statuses (:milestone/status %))
                  (fu/substring-search? (:name %) search-string)))
        (sort-by :milestone_start_date)
        (reverse))))

(re-frame/reg-sub
 ::milestone
 (fn [db [_ id]]
   (get-in db [:milestones id])))

(defn milestone-title [{:keys [name milestone_status archived] :as milestone}]
  [:div.milestone-title {:title name}
   [:a.undecorated-link
    {:href  (router/get-href2 ::edit milestone)
     :class (dom/classes-pairs :completed (= milestone_status "Completed"))}
    name]
   (when archived
     [:span " | " [:span.status "Archived"]])])

(defn milestone-metadata [milestone]
  [:div.milestone-meta
   [:div.milestone-meta-column
    [:div.milestone-meta-item
     [:div.milestone-meta-label
      (get-translation "milestone.start-date" "Start date:")]
     [:div.milestone-meta-value
      (fu/formatted-local-date (:milestone_start_date milestone))]]
    [:div.milestone-meta-item
     [:div.milestone-meta-label
      (get-translation "milestone.status" "Status:")]
     [:div.milestone-meta-value
      (:milestone/status milestone)]]]
   [:div.milestone-meta-column
    [:div.milestone-meta-item
     [:div.milestone-meta-label
      (get-translation "milestone.end-date" "End date:")]
     [:div.milestone-meta-value
      (fu/formatted-local-date (:milestone_end_date milestone))]]
    [:div.milestone-meta-item
     [:div.milestone-meta-label
      (get-translation "milestone.last-modified" "Last modified:")]
     [:div.milestone-meta-value
      (fu/formatted-date-time (:updated_at milestone))]]]])

(defn milestone-charts [milestone]
  [:div.milestone-charts
   (main-page-chart milestone :coverage "Coverage Status" :requirements)
   (main-page-chart milestone :execution  "Execution Status %" :testsets)])

(defn milestone-body [{:keys [id]}]
  (let [milestone @(re-frame/subscribe [::milestone id])]
    [:div.milestone-body
     [milestone-metadata milestone]
     [milestone-charts milestone]]))

(defn milestone-content [{:keys [archived] :as milestone}]
  [:div.milestone-content {:class (when archived "archived")}
   [milestone-title milestone]
   [milestone-body milestone]])

(def view-permission "milestones_view")
(def edit-permission "milestones_editor")
(def delete-permission "milestones_admin")

;; TODO: consider refactoring Archived should not be hardcoded
(defn milestone-status-dropdown []
  (let [fields           @(re-frame/subscribe [::subs/fields])
        values           (some-> fields :milestone_status :possible-values)
        possible-values  (for [v (cons "Archived" values)]
                           {:id v :label v})
        current-statuses @(re-frame/subscribe [::milestone.subs/milestone-filter-statuses])]
    [:div
     [:div.g2-field-container
      {:class (dom/classes-pairs :fixed-width true
                                 :field-1 true)}
      [:<>
       [selector2/new-select {:items       possible-values
                              :id          :milestone-status
                              :label-fn    :label
                              :placeholder (get-translation "generic.list.placeholder" "Filter by status")
                              :clearable?  false
                              :multi?      true
                              :tags?       false
                              :value       (mapv
                                            (fn [status]
                                              {:id status :label status})
                                            current-statuses)
                              :on-change   (fn [value]
                                             (let [val (if (empty? value)
                                                         possible-values
                                                         value)]
                                               (re-frame/dispatch [::milestone.events/show-milestones-by-status val])))}]]]]))


(defn toolbar [state]
  [:div.milestones-toolbar
   [:div.milestones-header
    (format-translation
     (get-translation "milestones.header" "Milestones (%{n})")
     :n (count @(re-frame/subscribe [::filtered-milestones @state])))]
   [milestone-status-dropdown]
   [search-box/search-textbox
    {:placeholder (get-translation "milestone.search-placeholder" "Search a Milestone")
     :value (:search-string @state)
     :on-change #(swap! state assoc :search-string (dom/event-value %))
     :on-clear-click #(swap! state assoc :search-string "")}]
   (when (permissions/has-permission? edit-permission)
     [buttons/button
      {:on-click (fn [_]
                   (mixpanel/track "New Entity" {"Entity" "Milestone"}))
       :icon [icons/mux-plus-circle]
       :primary? true
       :size "large"
       :text (get-translation "milestones.button.new" "New")
       :href (router/get-href ::new {:project-id (:id @(re-frame/subscribe [::subs/current-project]))})}])])

;; reitit controller to fetch data on route init
(def main-controller
  {:start    (fn [params]
               ;(js/console.log "on-start milestones" params)
               ;; TODO: entity and project id from params
               (re-frame/dispatch [::fetch]))
   ;; Extract parameters from match
   :identity :parameters})

(defn archive-menu-item [{:keys [id archived]}]
  (merge {:id   (str "milestone-" id "-archive")
          :icon icons/mux-archive}
         (if archived
           {:label    (get-translation "milestone.menu.unarchive" "Unarchive")
            :on-click #(re-frame/dispatch [::milestone.events/unarchive id])}
           {:label    (get-translation "milestone.menu.archive" "Archive")
            :on-click #(re-frame/dispatch [::milestone.events/archive id])})))

(def ^:private sprint-sync-new-plan-licenses #{"Corporate" "Team"})

(defn- jira-sprint-sync-banner []
  (let [current-user    @(re-frame/subscribe [::subs/current-user])
        storage-key     (str "milestone-jira-sprint-sync-banner-dismissed-" (:id current-user))
        dismissed?      (reagent/atom (boolean (dom/get-item storage-key)))]
    (fn []
      (let [current-project  @(re-frame/subscribe [::subs/current-project])
            license          (get-in @(re-frame/subscribe [::subs/current-account]) [:license])
            sync-enabled?    @(re-frame/subscribe [::subs/milestone-sprint-sync-enabled?])
            bugtracker-raw   (bugtracker/bugtracker-type current-project)
            jira?            (bugtrackers/jira? bugtracker-raw)
            new-plan?        (contains? sprint-sync-new-plan-licenses license)
            cloud?           (= :jiracloud (when bugtracker-raw (keyword (str/lower-case bugtracker-raw))))
            help-url         (if cloud?
                               broutes/jira-cloud-sprint-sync-url
                               broutes/jira-server-sprint-sync-url)]
        (when (and jira? new-plan? (not sync-enabled?) (not @dismissed?))
          [info-note/mux-info-note
           {:class    "mux-info-note-no-margin"
            :on-close (fn []
                        (dom/set-item storage-key "true")
                        (reset! dismissed? true))
            :message  [:<>
                       [:strong (get-translation "milestones.sprint-sync-banner.title"
                                                 "Still Creating Milestones Manually?")]
                       " "
                       (get-translation "milestones.sprint-sync-banner.body"
                                        "You can automatically sync Jira Sprints into PractiTest milestones.")
                       " "
                       [:a {:href help-url :target "_blank" :rel "noopener noreferrer"}
                        (get-translation "milestones.sprint-sync-banner.link"
                                         "Learn How to Set up Sprint Sync")]]}])))))

(defn index []
  (let [state (reagent/atom {:search-string ""})]
    (fn []
      (let [mri-ff-enabled? @(re-frame/subscribe [::subs/milestone-readiness-index-enabled?])
            component       (if mri-ff-enabled?
                              ri/card
                              milestone-content)]
        [:div.milestones-container
         [toolbar state]
         [jira-sprint-sync-banner]
         (let [project-id (:id @(re-frame/subscribe [::subs/current-project]))
               entities   (re-frame/subscribe [::filtered-milestones @state])]
           [card-view/view
            {:on-visibility-change (fn [id visible?]
                                     (re-frame/dispatch [::set-milestone-visibility
                                                         (parse-long id) visible?]))
             
             :entities   entities
             :component  component
             :menu-items (fn [entity]
                           (remove
                            nil?
                            [(when (permissions/has-permission? view-permission)
                               ;; a user with view permissions can enter a milestone and view without editing.
                               {:id    (str "milestone-" (:id entity) "-edit")
                                :label (get-translation "generic.button.edit" "Edit")
                                :icon  icons/mux-pencil
                                :href  (router/get-href ::edit
                                                        {:project-id   project-id
                                                         :milestone-id (:id entity)}
                                                        {}
                                                        {:tab :general})})

                             (when (permissions/has-permission? delete-permission)
                               {:id           (str "milestone-" (:id entity) "-delete")
                                :label        (get-translation "generic.button.delete" "Delete")
                                :icon         icons/mux-trash
                                :on-click     (fn []
                                                (mixpanel/track "Grid Actions" {"Action" "Delete Milestone"})
                                                (re-frame/dispatch [::milestone.events/delete (:id entity)]))
                                :confirmation {:title     (get-translation "milestone.delete-confirmation.title"
                                                                           "Delete Milestone?")
                                               :body      (format-translation
                                                           (get-translation "milestone.delete-confirmation.body"
                                                                            "\"%{milestone-name}\" will be deleted permanently.")
                                                           :milestone-name (fu/truncate-text (:name entity) 30))
                                               :yes-label (get-translation "generic.button.delete"
                                                                           "Delete")
                                               :no-label  (get-translation "generic.button.cancel"
                                                                           "Cancel")}})
                             (when (permissions/has-permission? edit-permission)
                               (archive-menu-item entity))]))}])]))))

(defn dashboard-page [_]
  (reagent/create-class
   {:component-did-mount (fn [this]
                           ;; TODO move to tab-level (dashboard) controller
                           (let [props (second (reagent/argv this))]
                             (re-frame/dispatch [::fetch-chart-data-by-id (:entity-id props)])))
    :reagent-render (fn [props]
                      (let [milestone @(re-frame/subscribe [::milestone (:entity-id props)])
                            status-colors @(re-frame/subscribe [::subs/status-colors])]
                        [:div.milestone-dashboard-tab
                         [:div.pie-charts-wrapper
                          [dashboard-pie-chart milestone status-colors :coverage
                           (get-translation "milestone.dashboard.pie-chart.requirement-coverage" "Requirement’s Coverage")]
                          [dashboard-pie-chart milestone status-colors :execution
                           (get-translation "milestone.dashboard.pie-chart.instances-by-status" "Instances by Status")]
                          [dashboard-pie-chart milestone status-colors :issues
                           (get-translation "milestone.dashboard.pie-chart.issues-by-status" "Issues by Status")]]

                                        ; not displaying for now since we only save the data of the last 90 days
                         (comment [:div.chart-container.progress-charts-wrapper
                                   [dashboard-progress-chart milestone status-colors :execution_progress "Execution Progress"]])]))}))

  ;; TODO: when there is no data to show, show "No data yet, start planning the milestone"

(defn row-menu [row])
  ;; TODO: implement

(defn grid-page-toolbar [{:keys [selected-entities
                                 on-unlink
                                 edit-permissions?
                                 delete-label
                                 link-label
                                 toggle-link-entities-modal!] :as form-props}
                         grid-props]
  [:div.milestone-grid-toolbar
   (let [selection @selected-entities]
     [buttons/button
      {:disabled? (or (grid.subs/empty-selection? selection)
                      (not edit-permissions?))
       :toolbar? true
       :on-click (fn [_]
                   (when on-unlink
                     (on-unlink selection)))
       :icon [icons/dash-circle]
       :text delete-label}])

   [buttons/button
    {:primary? true
     :toolbar? true
     :disabled? (not edit-permissions?)
     :on-click toggle-link-entities-modal!
     :icon [icons/mux-link2]
     :text link-label}]

   [grid2/default-grid-more-button grid-props]])

(defn form-props->grid-props [grid-state
                              {:keys [edit-permissions?
                                      table-id
                                      state-key
                                      columns
                                      get-field-props
                                      data
                                      current-page
                                      total-count
                                      full-data?
                                      on-query-changed
                                      empty-table-message
                                      grid-class
                                      selected-entities
                                      selected?
                                      on-unlink
                                      all-selected?
                                      toggle-selection
                                      toggle-selection-page]}]
  (let [milestone-id @(re-frame/subscribe [::subs/current-entity-id :milestone])

        pre-columns []
        post-columns (when edit-permissions?
                       [{:header        ""
                         :field         :actions
                         :default-width 60
                         :width         70
                         :type          :custom
                         :text-align    :center
                         :resizable?    false
                         :sortable?     false
                         :systemcol?    true
                         :cell-fn       (fn [_column-info row]
                                          [row-menu row])}])

        table-id-entity (str table-id "-" milestone-id)]
    {:columns               @columns
     :fields                @(re-frame/subscribe [::subs/fields])
     :pre-columns           pre-columns
     :post-columns          post-columns

     :class                 grid-class
     :grid-state            grid-state
     :show-edit-columns?    true
     :data                  @data

     ;; Reused existing one
     :selected-entities     selected-entities
     :selected?             selected?
     :all-selected?         all-selected?
     :toggle-selection      toggle-selection
     :toggle-selection-page toggle-selection-page
     :on-unlink             on-unlink

     :current-page          @current-page
     :total-count           @total-count
     :full-data?            @full-data?
     :on-query-changed      on-query-changed

     :per-page-save         (reagent/partial grid-storage/save-per-page table-id)
     :per-page-load         (reagent/partial grid-storage/load-per-page table-id)

     :resizable?            true
     :columns-widths-save   (reagent/partial grid-storage/save-column-sizes table-id)
     :columns-widths-load   (reagent/partial grid-storage/load-column-sizes table-id)
     :columns-settings-save (reagent/partial grid-storage/save-column-settings table-id)
     :columns-settings-load (reagent/partial grid-storage/load-column-settings table-id)

     :autofilters-save      (reagent/partial grid-session-storage/save-autofilters table-id-entity)
     :autofilters-load      (reagent/partial grid-session-storage/load-autofilters table-id-entity)
     :sort-order-save       (reagent/partial grid-session-storage/save-sort-order table-id-entity)
     :sort-order-load       (reagent/partial grid-session-storage/load-sort-order table-id-entity)

     :empty-table-message   empty-table-message

     ;; Expand/collapse functionality
     :on-expand-click       (partial-dispatch [::common-events/toggle-expanded :milestone state-key])
     :expanded?             @(re-frame/subscribe [::grid.subs/expanded? :milestone state-key])

     ;; For filters
     :get-field-props       get-field-props}))

(defn grid-page [{:keys [link-entities-props] :as form-props}]
  (let [grid-state (reagent/atom {})
        container-ref (atom nil)]
    (fn [_]
      [:div.milestone-grid-container
       {:ref #(reset! container-ref %)}

       [add-entities/add-entities-dialog
        container-ref
        (merge link-entities-props
               (select-keys form-props [:get-field-props]))]

       [grid2/grid (assoc (form-props->grid-props grid-state form-props)
                     :grid-toolbar (fn [grid-props]
                                     [grid-page-toolbar form-props grid-props]))]])))

(defn grid-options [{:keys [state-key
                            table-id-suffix]}]
  {:state-key             state-key
   :table-id              (str (:id @(re-frame/subscribe [::subs/current-project]))
                               "-milestone-" table-id-suffix)
   :grid-class            "data-grid-milestone-entities"

   :data                  (re-frame/subscribe [::grid.subs/data [:milestone state-key]])
   :columns               (re-frame/subscribe [::grid.subs/columns [:milestone state-key]])

   :selected-entities     (re-frame/subscribe [::grid.subs/selection [:milestone state-key]])
   :selected?             #(re-frame/subscribe [::grid.subs/selected? [:milestone state-key] %])
   :all-selected?         #(re-frame/subscribe [::grid.subs/all-selected? [:milestone state-key] %])
   :toggle-selection      (partial-dispatch [::grid.events/toggle-selection [:milestone state-key]])
   :toggle-selection-page (partial-dispatch [::grid.events/toggle-selection-page [:milestone state-key]])
   :current-page          (re-frame/subscribe [::milestone.subs/entities-current-page state-key])
   :total-count           (re-frame/subscribe [::milestone.subs/entities-total-count state-key])
   :full-data?            (re-frame/subscribe [::milestone.subs/entities-full-data? state-key])})

(defn link-entities-dialog-options [{:keys [state-key query-event link-event default-filter-name]}]
  {:show? (re-frame/subscribe [::milestone.subs/show-link-entities-modal? state-key])
   :hide! #(re-frame/dispatch [::milestone.events/hide-link-entities-modal state-key])
   :show-views? (re-frame/subscribe [::milestone.subs/link-entities-show-views? state-key])
   :filters (re-frame/subscribe [::milestone.subs/link-entities-filters state-key default-filter-name])
   :current-filter-selected (re-frame/subscribe [::milestone.subs/link-entities-current-filter-selected state-key])
   :set-current-filter (partial-dispatch [::milestone.events/set-link-entities-dialog-grid-filter state-key query-event])
   :set-current-folder (partial-dispatch [::common-events/set-current-folder :testset :link-testsets-state
                                       ::common-events/fetch-entity-list-by-folder])
   :on-query-changed (partial-dispatch [query-event])
   :on-add-entities (partial-dispatch [link-event])
   ;; TODO: this should be part of the `grid-options` function
   ;;       but right now it looks like loading indicator is not shown anymore, so it doesn't matter until we fix it
   :loading? (re-frame/subscribe [::subs/progress? query-event])})

(defn requirements-page [form-props]
  (let [entity @(re-frame/subscribe [::subs/entity :milestone (:entity-id form-props)])
        entity-name (:name (:current entity))
        disabled-row? (fn [row]

                        ;; do not allow selection of requirements already linked to this milestone
                        (let [milestone-ids (set (:milestone_ids row))]
                          (contains? milestone-ids (:entity-id form-props))))
        linked-to-other-milestone? (fn [row]
                                     ;; we need to highlight requirements that are linked to other milestones
                                     (let [milestone-ids (set (:milestone_ids row))]
                                       (not-empty (disj milestone-ids (:entity-id form-props)))))
        link-entities-props
        (merge (grid-options {:state-key       :link-requirements-state
                              :table-id-suffix "link-requirements-grid"})
               (link-entities-dialog-options {:state-key :link-requirements-state
                                              :query-event ::milestone.events/fetch-requirements
                                              :link-event ::milestone.events/link-requirements
                                              :module "Requirement"
                                              :default-filter-name "All Requirements"})
               {
                :module "Requirement"
                :title (get-modal-title
                         (get-translation "milestone.requirements.link" "Link Requirements")
                         (get-translation "to.milestone" "to Milestone")
                         (:entity-id form-props)
                         entity-name)
                :disabled-row? disabled-row?
                :disabled-row-tooltip (fn [_row]
                                        (get-translation "milestone.requirements.disabled-row.tooltip"
                                                         "Requirement already linked to this milestone"))
                :disabled-select-all? #(some disabled-row? %)
                :disabled-select-all-tooltip (get-translation "milestone.requirements.disabled-select-all.tooltip"
                                                              "Cannot select all requirements because some of the requirements already linked to this milestone")
                :alt-highlight-row? linked-to-other-milestone?
                :allows-added-rows? true
                :added-row-tooltip (get-translation "milestone.requirements.added-row.tooltip"
                                                    "This Requirement is already linked to other milestones")
                :add-entities-button-label (get-translation "milestone.requirements.link-button"
                                                            "Link %{n} Requirements")})]
    [grid-page
     (merge form-props
            (grid-options {:state-key       :requirements-state
                           :table-id-suffix "requirements-grid"})
            {:on-query-changed            (partial-dispatch [::milestone.events/fetch-linked-requirements])
             :empty-table-message         (get-translation "milestone.requirements.add-requirements-to-your-milestone"
                                                           "Add requirements to your milestone")
             :delete-label                (get-translation "generic.button.remove"
                                                           "Remove")
             :on-unlink                   #(re-frame/dispatch [::milestone.events/unlink-requirements %])
             :link-label                  (get-translation "milestone.requirements.link"
                                                           "Link Requirements")
             :module "Requirement"
             :toggle-link-entities-modal! (fn [_e]
                                            (re-frame/dispatch [::common-events/toggle-link-entities-modal
                                                                :requirement
                                                                :link-requirements-state
                                                                ::milestone.events/fetch-requirements
                                                                (reagent/partial grid-storage/load-per-page (:table-id link-entities-props))])
                                            (mixpanel/track "Milestone - Link Requirement"))
             :link-entities-props         link-entities-props})]))

(defn testsets-page [form-props]
  (let [disabled-row? (fn [row]
                        ;; do not allow selection of testsets linked to any milestone
                        (not (nil? (:milestone_id row))))
        entity @(re-frame/subscribe [::subs/entity :milestone (:entity-id form-props)])
        entity-name (:name (:current entity))
        link-entities-props
        (merge (grid-options {:state-key       :link-testsets-state
                              :table-id-suffix "link-testsets-grid"})
               (link-entities-dialog-options {:state-key :link-testsets-state
                                              :query-event ::milestone.events/fetch-testsets
                                              :link-event ::milestone.events/link-testsets
                                              ;; TODO: localization for default filter name
                                              :default-filter-name "All Test Sets"})
               {
                :module "TestSet"
                :title (get-modal-title
                         (get-translation "milestone.testsets.link" "Link Test Sets")
                         (get-translation "to.milestone" "to Milestone")
                         (:entity-id form-props)
                         entity-name)
                :disabled-row? disabled-row?
                :disabled-row-tooltip (fn [row]
                                        (if (= (get-in row [:milestone :id])
                                               (:entity-id form-props))
                                          (get-translation "milestone.testsets.disabled-row.this.tooltip"
                                                           "Test Set already linked to this milestone")
                                          (get-translation "milestone.testsets.disabled-row.other.tooltip"
                                                           "Test Set already linked to another milestone")))
                :disabled-select-all? #(some disabled-row? %)
                :disabled-select-all-tooltip (get-translation "milestone.testsets.disabled-select-all.tooltip"
                                                              "Cannot select all testsets because some of the testsets already linked to this or other milestones")
                :add-entities-button-label (get-translation "milestone.testsets.link-button"
                                                            "Link %{n} Test Sets")})]
    [grid-page
     (merge form-props
            (grid-options {:state-key       :testsets-state
                           :table-id-suffix "testsets-grid"})
            {:on-query-changed            (partial-dispatch [::milestone.events/fetch-linked-testsets])
             :empty-table-message         (get-translation "milestone.testsets.add-testsets-to-your-milestone"
                                                           "Add test sets to your milestone")
             :delete-label                (get-translation "generic.button.remove"
                                                           "Remove")
             :on-unlink #(re-frame/dispatch [::milestone.events/unlink-testsets %])
             :link-label                  (get-translation "milestone.testsets.link"
                                                           "Link Test Set")
             :toggle-link-entities-modal! (fn [_e]
                                            (re-frame/dispatch [::common-events/toggle-link-entities-modal
                                                                :testset
                                                                :link-testsets-state
                                                                ::milestone.events/fetch-testsets
                                                                (reagent/partial grid-storage/load-per-page (:table-id link-entities-props))])
                                            (mixpanel/track "Milestone - Link Test Set"))
             :link-entities-props         link-entities-props})]))

(defn issues-page [form-props]
  (let [disabled-row? (fn [row]
                                 ;; do not allow selection of issues already linked to this milestone
                        (let [milestone-ids (set (:milestone_ids row))]
                          (contains? milestone-ids (:entity-id form-props))))
        linked-to-other-milestone? (fn [row]
                                     ;; we need to highlight issues that are linked to other milestones
                                     (let [milestone-ids (set (:milestone_ids row))]
                                       (not-empty (disj milestone-ids (:entity-id form-props)))))
        entity @(re-frame/subscribe [::subs/entity :milestone (:entity-id form-props)])
        entity-name (:name (:current entity))
        link-entities-props
        (merge (grid-options {:state-key       :link-issues-state
                              :table-id-suffix "link-issues-grid"})
               (link-entities-dialog-options {:state-key :link-issues-state
                                              :query-event ::milestone.events/fetch-issues
                                              :link-event ::milestone.events/link-issues
                                              ;; TODO: localization for default filter name
                                              :default-filter-name "All Issues"})
               {
                :module "Issue"
                :title (get-modal-title
                         (get-translation "milestone.issues.link" "Link Issues")
                         (get-translation "to.milestone" "to Milestone")
                         (:entity-id form-props)
                         entity-name)
                :disabled-row? disabled-row?
                :disabled-row-tooltip (fn [_row]
                                        (get-translation "milestone.issues.disabled-row.tooltop"
                                                         "Issue already linked to this milestone"))
                :disabled-select-all? #(some disabled-row? %)
                :disabled-select-all-tooltip (get-translation "milestone.issues.disabled-select-all.tooltip"
                                                              "Cannot select all issues because some of the issues already linked to this milestone")
                :alt-highlight-row? linked-to-other-milestone?
                :added-row-tooltip (get-translation "milestone.issues.added-row.tooltip"
                                                    "This Issue is already linked to other milestones")
                :add-entities-button-label (get-translation "milestone.issues.link-button"
                                                            "Link %{n} Issues")})]
    [grid-page
     (merge form-props
            (grid-options {:state-key       :issues-state
                           :table-id-suffix "issues-grid"})
            {:on-query-changed            (partial-dispatch [::milestone.events/fetch-linked-issues])
             :empty-table-message         (get-translation "milestone.issues.add-issues-to-your-milestone"
                                                           "Add issues to your milestone")
             :delete-label                (get-translation "generic.button.remove"
                                                           "Remove")
             :on-unlink #(re-frame/dispatch [::milestone.events/unlink-issues %])
             :link-label                  (get-translation "milestone.issues.link" "Link Issue")
             :toggle-link-entities-modal! (fn [_e]
                                            (re-frame/dispatch [::common-events/toggle-link-entities-modal
                                                                :issue
                                                                :link-issues-state
                                                                ::milestone.events/fetch-issues
                                                                (reagent/partial grid-storage/load-per-page (:table-id link-entities-props))])
                                            (mixpanel/track "Milestone - Link Issue"))
             :link-entities-props         link-entities-props})]))

(defn build-milestone-tabs-form3
  [edit?]
  (concat
    [(f3.entity-form/general-entity-tab)]

    (when edit?
      [{:tab-id    :dashboards
        :tab-title (get-translation "milestone.tab.dashboard" "Dashboard")
        :tab-view  dashboard-page}

       {:tab-id    :requirements
        :tab-title [:span.text-nowrap
                    (format-translation
                      (get-translation "milestone.tab.requirements" "Requirements (%{n})")
                      :n (or @(re-frame/subscribe [::milestone.subs/entities-total-count
                                                   :requirements-state])
                             "⋯"))]
        :tab-view  requirements-page}

       {:tab-id    :testsets
        :tab-title [:span.text-nowrap
                    (format-translation
                      (get-translation "milestone.tab.testsets" "Test Sets (%{n})")
                      :n (or @(re-frame/subscribe [::milestone.subs/entities-total-count
                                                   :testsets-state])
                             "⋯"))]
        :tab-view  testsets-page}

       {:tab-id    :issues
        :tab-title [:span.text-nowrap
                    (format-translation
                      (get-translation "milestone.tab.issues" "Issues (%{n})")
                      :n (or @(re-frame/subscribe [::milestone.subs/entities-total-count
                                                   :issues-state])
                             "⋯"))]
        :tab-view  issues-page}

       (f3.entity-form/history-tab)])))

(defn new-controller []
  {:start (fn [params]
            (re-frame/dispatch [::forms/reset-form-state true :milestone milestone-form-id []])
            (re-frame/dispatch [::events/set-current-entity-type :milestone])

            (let [project-id (get-in params [:path :project-id])]
              (re-frame/dispatch [::f3.entity-form/fetch-fields {:form-id     milestone-form-id
                                                                 :entity-type :milestone
                                                                 :project-id  project-id
                                                                 :new?        true}])))
   :identity :parameters})

(defn edit-controller []
  {:start    (fn [params]
               (let [{:keys [milestone-id project-id]} (:path params)]
                 (re-frame/dispatch [::forms/reset-form-state false :milestone milestone-form-id []])
                 (re-frame/dispatch [::events/set-current-entity-type :milestone])
                 (re-frame/dispatch [::subs/set-current-entity-id
                                     :milestone
                                     milestone-id])

                 (let [fetch-options {:form-id milestone-form-id
                                      :entity-type :milestone
                                      :entity-id milestone-id
                                      :project-id project-id
                                      :new? false}]
                   (re-frame/dispatch [::f3.entity-form/fetch-fields fetch-options])
                   (re-frame/dispatch [::f3.entity-form/fetch-entity fetch-options])
                   (re-frame/dispatch [::collab-ws/subscribe-to-form-ws [(:plural-key metadata)]]))
                 ;; XXX: should we only fetch data for specific tab when the tab is activated?
                 ;;      probably not because we need the counts in the tab headers
                 (re-frame/dispatch [::milestone.events/fetch-linked-requirements])
                 (re-frame/dispatch [::milestone.events/fetch-linked-testsets])
                 (re-frame/dispatch [::milestone.events/fetch-linked-issues])
                 (re-frame/dispatch [::events/fetch-comments])
                 (re-frame/dispatch [::events/fetch-attachments])
                 (re-frame/dispatch [::events/fetch-history])
                 (re-frame/dispatch [::common-events/trigger-online-request])
                 (mixpanel/track "Grid Actions" {"Action" "Edit Milestone"})))
   :stop     (fn [_params]
               (re-frame/dispatch [::events/clear-current-entity :milestone])
               (re-frame/dispatch [::collab-ws/unsubscribe-form-ws [(:plural-key metadata)]])
               (re-frame/dispatch [::common-events/reset-expanded :milestone [:issues-state
                                                                              :testsets-state
                                                                              :requirements-state
                                                                              :history2]])
               (re-frame/dispatch [::forms/reset-form-state false :milestone :milestone []]))
   :identity :parameters})

(defn main [new?]
  [f3.milestone-form/main new? (build-milestone-tabs-form3 (not new?))])

(defn ^:export init [options]
  (let [{:keys [translation]} (-> options (js->clj :keywordize-keys true))]
    (i18n/append-translation! @(re-frame/subscribe [::subs/current-locale]) translation)))
